import PropTypes from "prop-types";
import {createNotification} from "app/actions/notifications";
import {destroy as destroyRecord} from "app/requests/admin/authors";
import useAppContext from "lib/hooks/use-app-context";
import {displayDateTime} from "lib/string";

function AdminAuthorsListRow({record, onDestroy}) {
  const {dispatch} = useAppContext();
  const onDelete = () => {
    if(!window.confirm("Are you sure you want to delete this author?")) { return; }

    destroyRecord(record.id).then(({message, success}) => {
      dispatch(createNotification({content: message, type: success ? "success" : "danger"}));

      if(success) { onDestroy(record.id); }
    });
  };

  return (
    <tr>
      <td>{record.first_name}</td>
      <td>{record.last_name}</td>
      <td>{record.email || "None"}</td>
      <td>{record.data.link ? <a href={record.data.link} rel="noreferrer" target="_blank">View</a> : "None"}</td>
      <td>{displayDateTime(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <a className="btn btn-sm btn-primary" href={`/admin/authors/${record.id}`}>Edit</a>
          <button className="btn btn-sm btn-danger" onClick={onDelete} type="button">Destroy</button>
        </div>
      </td>
    </tr>
  );
}

AdminAuthorsListRow.propTypes = {
  onDestroy: PropTypes.func.isRequired,
  record: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      credentials: PropTypes.string,
      link: PropTypes.string
    }).isRequired,
    email: PropTypes.string,
    first_name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    last_name: PropTypes.string.isRequired
  }).isRequired
};

export default AdminAuthorsListRow;
